import { PanelLeftText20Regular } from '@ms/yammer-web-core-ui/dist/components/FluentUISystemIcon';
import { Button } from '@ms/yammer-web-core-ui/dist/fluent9/components/Button';
import { Tooltip } from '@ms/yammer-web-core-ui/dist/fluent9/components/Tooltip';
import type { FC } from 'react';
import React from 'react';

import { useClassNames } from './CollapseIconButton.styles';
import CollapsedRailIconButton from './CollapsedRailIconButton';

export type CollapseIconButtonAppearance = 'subtle' | 'transparent';

export interface CollapseIconButtonProps {
  readonly ariaLabel: string;
  readonly ariaExpanded: boolean;
  readonly appearance: CollapseIconButtonAppearance;
  readonly onClick: () => void;
}

const CollapseIconButton: FC<CollapseIconButtonProps> = ({ ariaLabel, ariaExpanded, appearance, onClick }) => {
  const classNames = useClassNames();

  if (appearance === 'transparent') {
    return (
      <CollapsedRailIconButton
        ariaLabel={ariaLabel}
        ariaExpanded={ariaExpanded}
        icon={<PanelLeftText20Regular />}
        onClick={onClick}
      />
    );
  }

  return (
    <Tooltip content={ariaLabel} relationship="description" positioning="before">
      <Button
        className={classNames.button}
        appearance="subtle"
        icon={<PanelLeftText20Regular />}
        aria-label={ariaLabel}
        aria-expanded={ariaExpanded}
        onClick={onClick}
      />
    </Tooltip>
  );
};

export default CollapseIconButton;
